import { Box, Flex, Select, Stack, Table, TableContainer, Tbody, Text, Th, Thead, Tr } from '@chakra-ui/react'
import React, { useRef, useState } from 'react'
import Input from '../Components/Input';
import MainLayout from '../Layouts/Index'
import Seo from '../Utils/Seo'
import { BsCalendar2Date } from 'react-icons/bs';
import Button from '../Components/Button';
import moment from 'moment';
import { GetAllReport } from '../Utils/ApiCalls';
import TableRow from '../Components/TableRow';
import ColorCode from '../Components/ColorCode';
import * as XLSX from 'xlsx/xlsx.mjs';
import Preloader from '../Components/Preloader';
import SearchComponent from '../Components/SearchComponent';





export default function Report() {

  const [Report, setReport] = useState({
    typeof: "",//sra,shelf,scn
    fromDate: "",
    toDate: "",
    store: ""


  });


  const [Data, setData] = useState([]);
  const [Show, setShow] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [PreLoader, setPreLoader] = useState(false);

  const [SearchText, setSearchText] = useState("");


  const GetReport = async () => {
    setLoading(true)
    setPreLoader(true)
    let result = await GetAllReport(Report.typeof, Report.store, Report.fromDate, Report.toDate)

    console.log("GetAllReport", result);

    if (result.status === true) {
      setData(result.queryresult)
      setShow(true)
      setLoading(false)
      setPreLoader(false)
    }
  }


  const handleReport = (e) => {
    setData([])
    setShow(false)

    setReport({ ...Report, [e.target.id]: e.target.value })
  }




  const DownloadFile = () => {

    var workbook = XLSX.utils.book_new();

    var worksheet = XLSX.utils.json_to_sheet(Data);

    XLSX.utils.book_append_sheet(workbook, worksheet);

    let date = moment(Date.now()).format("DD/MM/YYYY")

    XLSX.writeFile(workbook, `${date}_Ims_${Report.typeof}_report.xlsx`);
  }


  return (
    <MainLayout>
      {
        PreLoader && (

          <Preloader />
        )
      }
      <Seo title='Report' description='EKO IMS - Report' />
      <Text fontWeight={"600"}>Get Report</Text>
      <Box rounded="8px" bg="#ddd" px="1%" py="10px">
        <Flex justifyContent={"space-between"} spacing={"15px"} color="#000">
          <Box>
            <Text fontWeight={"500"} pb="5px"> Type of Report</Text>
            <Select borderColor={"#000"} color={"#000"} placeholder='Select Report type' _focus={{ borderColor: "blue.blue400" }} fontWeight={"400"} fontSize={Report.typeof != "" ? "16px" : "12px"} id='typeof' value={Report.typeof} onChange={handleReport}>

              <option value="shelf" >Shelf</option>
              <option value="sra" >Sra</option>
              <option value="scn" >Scn</option>
              <option value="request" >Request</option>
              <option value="transfer" >Transfer</option>

            </Select>

          </Box>
          <Box>
            <Text fontWeight={"500"} pb="5px"> Type of Store</Text>
            <Select borderColor={"#000"} color={"#000"} placeholder='Select Store' _focus={{ borderColor: "blue.blue400" }} fontWeight={"400"} fontSize={Report.store != "" ? "16px" : "12px"} id='store' value={Report.store} onChange={handleReport}>

              <option value="1" >Admin Store Marina</option>
              <option value="2" >Central Circle stores, Ijora</option>
              <option value="3" >East Circle stores, Island</option>
              <option value="4" >West Circle stores, Festac</option>

            </Select>

          </Box>
          <Box>
            <Text fontWeight={"500"} pb="5px"> From Date</Text>

            <Input py="-2px !important" bColor={"#000"} leftIcon={<BsCalendar2Date />} iconColor="black" id="fromDate" type='date' value={Report.fromDate} val={Report.fromDate !== "" ? true : false} onChange={handleReport} />
          </Box>
          <Box>
            <Text fontWeight={"500"} pb="5px"> To Date</Text>
            <Input bColor={"#000"} py="20px !important" leftIcon={<BsCalendar2Date />} iconColor="black" color="#000" id="toDate" type='date' value={Report.toDate} val={Report.toDate !== "" ? true : false} onChange={handleReport} />
          </Box>


        </Flex>

        <Button mt={"20px"} isLoading={Loading} disabled={Report.typeof !== "" && Report.fromDate !== "" && Report.toDate !== "" && Report.store !== "" ? false : true} onClick={GetReport}>Get Report</Button>
      </Box>

      {
        Show && (
          <>
          <SearchComponent SearchText={SearchText} setSearchText={(e) => setSearchText(e.target.value)} Keywords={"Product Name"} />
          <Box w={"100%"} overflow={"auto"} rounded="8px" mt="10px" bg="blue.blue300" px="1%" py="10px">

{
  Show && Report.typeof === "sra" && (
    <Box>

      <Text color={"#fff"} textAlign={"center"}>Report of SRA from {moment(Report.fromDate).format("LL")} to {moment(Report.toDate).format("LL")}</Text>

      <Box display={"flex"} justifyContent="flex-end">
        <Text cursor="pointer" mt={"10px"} w="50%" bg="teal" color="#fff" textAlign={"center"} p="8px" rounded="8px" onClick={DownloadFile} > Download file</Text>

      </Box>


      <TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff"

      >
        <Table variant='simple' size='sm' overflowX="auto" >
          <Thead>
            <Tr>
              <Th color="#fff">S/N</Th>
              <Th color="#fff">SRA Number</Th>
              <Th color="#fff">Item Number</Th>
              <Th color="#fff">Date received</Th>
              <Th color="#fff">Invoice Number</Th>
              <Th color="#fff">Raised</Th>

            </Tr>
          </Thead>
          <Tbody>

            {

              SearchText === "" ? (
                Data.map((item, i) => (
                  <TableRow
                    key={i}
                    sn={i + 1}
                    type="sraReport"
                    sraNo={item.sra[0]?.sranumber}
                    itemNo={item.sra[0]?.itemnos}
                    dateReceived={moment(item.sra[0]?.datereceived).format("DD/MM/YYYY")}
                    invoiceNo={item.sra[0]?.invoicenumber}
                    raised={item.sra[0]?.raised}


                  />
                ))
              ) : (

                SearchText !== "" && Data.filter(item => item.productname?.toLowerCase().includes(SearchText.toLowerCase())).length > 0 ? (

                  Data.filter(item => item.productname?.toLowerCase().includes(SearchText.toLowerCase())).
                    map((item, i) => (
                      <TableRow
                        key={i}
                        sn={i + 1}
                        type="sraReport"
                        sraNo={item.sra[0]?.sranumber}
                        itemNo={item.sra[0]?.itemnos}
                        dateReceived={moment(item.sra[0]?.datereceived).format("DD/MM/YYYY")}
                        invoiceNo={item.sra[0]?.invoicenumber}
                        raised={item.sra[0]?.raised}

                      />
                    ))

                ) : (
                  <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>
                )


              )

            }




          </Tbody>

        </Table>
      </TableContainer>



    </Box>
  )
}


{
  Show && Report.typeof === "shelf" && (


    <Box>



      <Text color={"#fff"} textAlign={"center"}>Report of Shelf from {moment(Report.fromDate).format("LL")} to {moment(Report.toDate).format("LL")}</Text>

      <Box display={"flex"} justifyContent="flex-end">
        <Text cursor="pointer" mt={"10px"} w="50%" bg="teal" color="#fff" textAlign={"center"} p="8px" rounded="8px" onClick={DownloadFile}>Download file</Text>

      </Box>
      <ColorCode />

      <TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff"

      >
        <Table variant='simple' size='sm' overflowX="auto" >
          <Thead>
            <Tr>
              <Th color="#fff">S/N</Th>
              <Th color="#fff">ProductName</Th>
              <Th color="#fff">shelfID</Th>
              <Th color="#fff">Qty Group</Th>
              <Th color="#fff">Date Modified</Th>

            </Tr>
          </Thead>
          <Tbody>

            {
              SearchText === "" ? (
                Data.map((item, i) => (
                  <TableRow
                    key={i}
                    sn={i + 1}
                    type="shelfReport"
                    productName={item.productname}
                    productShelfId={item.productshelfid}
                    qty={item.qty}
                    qtyServiceable={item.qtyserviceable}
                    qtyUnserviceable={item.qtyunserviceable}

                    unit={moment(item.updatedAt).format("DD/MM/YYYY")}

                  />
                ))
              ) : (

                SearchText !== "" && Data.filter(item => item.productname?.toLowerCase().includes(SearchText.toLowerCase())).length > 0 ? (

                  Data.filter(item => item.productname?.toLowerCase().includes(SearchText.toLowerCase())).
                    map((item, i) => (
                      <TableRow
                        key={i}
                        sn={i + 1}
                        type="shelfReport"
                        productName={item.productname}
                        productShelfId={item.productshelfid}
                        qty={item.qty}
                        qtyServiceable={item.qtyserviceable}
                        qtyUnserviceable={item.qtyunserviceable}

                        unit={moment(item.updatedAt).format("DD/MM/YYYY")}

                      />
                    ))

                ) : (
                  <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>
                )


              )

            }




          </Tbody>

        </Table>
      </TableContainer>



    </Box>
  )
}


{
  Show && Report.typeof === "scn" && (
    <Box>

      <Text color={"#fff"} textAlign={"center"}>Report of SCN from {moment(Report.fromDate).format("LL")} to {moment(Report.toDate).format("LL")}</Text>

      <Box display={"flex"} justifyContent="flex-end">
        <Text cursor="pointer" mt={"10px"} w="50%" bg="teal" color="#fff" textAlign={"center"} p="8px" rounded="8px" onClick={DownloadFile}>Download file</Text>

      </Box>


      <TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff"

      >
        <Table variant='simple' size='sm' overflowX="auto" >
          <Thead>
            <Tr>
              <Th color="#fff">S/N</Th>
              <Th color="#fff">Name</Th>
              <Th color="#fff">Certified</Th>
              <Th color="#fff">Returned</Th>
              <Th color="#fff">Serviceable</Th>
              <Th color="#fff">Unserviceable</Th>
              <Th color="#fff">Date</Th>
              <Th color="#fff">ReturneeDept</Th>

            </Tr>
          </Thead>
          <Tbody>

            {



              SearchText === "" ? (
                Data.map((item, i) => (
                  <TableRow
                    key={i}
                    sn={i + 1}
                    type="scnReport"
                    productName={item.shelfid[0].productname}
                    qty={item.qtycertified}
                    qtyinspected={item.qtyreturned}
                    qtyServiceable={item.serviceable}
                    qtyUnserviceable={item.unserviceable}
                    dateReceived={moment(item.createdAt).format("DD/MM/YYYY")}
                    dept={item.returneedepartment}


                  />
                ))
              ) : (

                SearchText !== "" && Data.filter(item => item.shelfid[0].productname?.toLowerCase().includes(SearchText.toLowerCase())).length > 0 ? (

                  Data.filter(item => item.shelfid[0].productname?.toLowerCase().includes(SearchText.toLowerCase())).
                    map((item, i) => (
                      <TableRow
                        key={i}
                        sn={i + 1}
                        type="scnReport"
                        productName={item.shelfid[0].productname}
                        qty={item.qtycertified}
                        qtyinspected={item.qtyreturned}
                        qtyServiceable={item.serviceable}
                        qtyUnserviceable={item.unserviceable}
                        dateReceived={moment(item.createdAt).format("DD/MM/YYYY")}
                        dept={item.returneedepartment}

                      />
                    ))

                ) : (
                  <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>
                )


              )

            }




          </Tbody>

        </Table>
      </TableContainer>



    </Box>
  )
}



{
  Show && Report.typeof === "request" && (
    <Box overflowX="auto" width={"auto"}>

      <Text color={"#fff"} textAlign={"center"}>Report of Request from {moment(Report.fromDate).format("LL")} to {moment(Report.toDate).format("LL")}</Text>

      <Box display={"flex"} justifyContent="flex-end">
        <Text cursor="pointer" mt={"10px"} w="50%" bg="teal" color="#fff" textAlign={"center"} p="8px" rounded="8px" onClick={DownloadFile}>Download file</Text>

      </Box>



      <Table variant='simple' size='sm' overflowX="auto">
        <Thead>
          <Tr>
            <Th color="#fff">S/N</Th>
            <Th color="#fff">TicketNo</Th>
            <Th color="#fff">Name</Th>
            <Th color="#fff">staffId</Th>
            <Th color="#fff">Supervisor</Th>
            <Th color="#fff">Status</Th>
            <Th color="#fff">RequestDate</Th>

          </Tr>
        </Thead>
        <Tbody>

          {



            SearchText === "" ? (
              Data.map((item, i) => (
                <TableRow
                  key={i}
                  sn={i + 1}
                  type="requestReport"
                  ticketNo={item.ticket}
                  productName={item.shelfid[0]?.productname}
                  staffId={item.staffid}
                  supervisor={item.supervisor}
                  status={item.status}
                  dateReceived={moment(item.createdAt).format("DD/MM/YYYY")}


                />
              ))
            ) : (

              SearchText !== "" && Data.filter(item => item.shelfid[0].productname?.toLowerCase().includes(SearchText.toLowerCase())).length > 0 ? (

                Data.filter(item => item.shelfid[0].productname?.toLowerCase().includes(SearchText.toLowerCase())).
                  map((item, i) => (
                    <TableRow
                      key={i}
                      sn={i + 1}
                      type="requestReport"
                      ticketNo={item.ticket}
                      productName={item.shelfid[0]?.productname}
                      staffId={item.staffid}
                      supervisor={item.supervisor}
                      status={item.status}
                      dateReceived={moment(item.createdAt).format("DD/MM/YYYY")}
                    />
                  ))

              ) : (
                <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>
              )


            )
          }




        </Tbody>

      </Table>




    </Box>
  )
}



{
  Show && Report.typeof === "transfer" && (
    <Box>

      <Text color={"#fff"} textAlign={"center"}>Report of Transfer from {moment(Report.fromDate).format("LL")} to {moment(Report.toDate).format("LL")}</Text>

      <Box display={"flex"} justifyContent="flex-end">
        <Text cursor="pointer" mt={"10px"} w="50%" bg="teal" color="#fff" textAlign={"center"} p="8px" rounded="8px" onClick={DownloadFile}>Download file</Text>

      </Box>


      <TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff"

      >
        <Table variant='simple' size='sm' overflowX="auto" >
          <Thead>
            <Tr>
              <Th color="#fff">S/N</Th>
              <Th color="#fff">AandSEmail</Th>
              <Th color="#fff">Name</Th>
              <Th color="#fff">QtyTransfer</Th>
              <Th color="#fff">ReceivingStore</Th>
              <Th color="#fff">SendingStore</Th>
              <Th color="#fff">Status</Th>


            </Tr>
          </Thead>
          <Tbody>

            {

              SearchText === "" ? (
                Data.map((item, i) => (
                  <TableRow
                    key={i}
                    sn={i + 1}
                    type="transferReport"
                    email={item.aandsemail || ""}
                    productName={item.receivingshelfid[0].productname}
                    qty={item.qtytotransfer}
                    RStore={item.receivingshelfid[0].store}
                    SStore={item.sendingshelfid[0].store}
                    price={item.status}




                  />
                ))
              ) : (

                SearchText !== "" && Data.filter(item => item.receivingshelfid[0].productname?.toLowerCase().includes(SearchText.toLowerCase())).length > 0 ? (

                  Data.filter(item => item.receivingshelfid[0].productname?.toLowerCase().includes(SearchText.toLowerCase())).
                    map((item, i) => (
                      <TableRow
                        key={i}
                        sn={i + 1}
                        type="transferReport"
                        email={item.aandsemail || ""}
                        productName={item.receivingshelfid[0].productname}
                        qty={item.qtytotransfer}
                        RStore={item.receivingshelfid[0].store}
                        SStore={item.sendingshelfid[0].store}
                        price={item.status}


                      />
                    ))

                ) : (
                  <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>
                )


              )
            }




          </Tbody>

        </Table>
      </TableContainer>



    </Box>
  )
}

</Box>

          </>

        )
      }


   


    </MainLayout>
  )
}
